import { FormikErrors, useFormikContext } from 'formik';
import { FastField, Field } from '~/components/common/Formik';
import {
  Box,
  Divider,
  FormHelperText,
  FormLabel,
  Grid,
  Typography,
} from '@mui/material';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import themes from '~/themes';
import { Zone } from '~/models/stores';
import { DrawnZonesMap } from './DrawnZonesMap';

interface DialogAddZoneFormProps {
  zoneSelected?: Zone;
  defaultCenter?: {
    lat: number;
    lng: number;
  };
  setFieldValue: (
    field: string,
    value: any,
    shouldValidate?: boolean,
  ) => Promise<void | FormikErrors<any>>;
  delivery_fee_type: any;
  long_lat: any;
  drawnZoneMapRef: React.MutableRefObject<any>;
  missCoordinateErr: string;
}

type FeeTypeElementProps = {
  type: 'fixed_amount' | 'percentage';
  open: boolean;
  hideArrow?: boolean;
};

export const FeeTypeElement = ({
  type,
  open,
  hideArrow = false,
}: FeeTypeElementProps) => {
  const Icon = open ? KeyboardArrowDownIcon : KeyboardArrowUpIcon;

  return (
    <>
      <Typography color={themes.color.violet900}>
        {type === 'fixed_amount' ? '$' : '%'}
      </Typography>
      {!hideArrow && <Icon sx={{ color: themes.color.violet900 }} />}
    </>
  );
};

export const DialogAddZoneForm: React.FC<DialogAddZoneFormProps> = ({
  defaultCenter,
  long_lat,
  delivery_fee_type,
  setFieldValue,
  drawnZoneMapRef,
  missCoordinateErr,
}) => {
  const { values } = useFormikContext<any>();
  return (
    <Grid container spacing={2}>
      <Grid item xs={6}>
        <FastField.TextInput name='name' legend='Name' />
      </Grid>
      <Grid
        item
        xs={6}
        sx={{
          label: {
            marginTop: '12px',
          },
        }}
      >
        <Field.SwitchButton
          name='enable'
          legend='Status'
          label={values.enable ? 'Enabled' : 'Disabled'}
        />
      </Grid>
      <Grid item xs={6}>
        <Box mb={0.5} mt={-0.2}>
          <FormLabel>Delivery Fee</FormLabel>
        </Box>
        <Grid container spacing={1}>
          <Grid item xs={6} md={3}>
            <Field.Select
              name='delivery_fee_type'
              renderValue={(o: boolean) => (
                <FeeTypeElement open={o} type={delivery_fee_type} hideArrow />
              )}
              options={[
                {
                  label: 'Dollar Value',
                  value: 'fixed_amount',
                },
                {
                  label: 'Percentage',
                  value: 'percentage',
                },
              ]}
            />
          </Grid>
          <Grid item xs={6} md={9}>
            <Field.TextInput type='number' name='delivery_fee' />
          </Grid>
        </Grid>
      </Grid>
      <Grid item xs={6}>
        <FastField.TextInput
          type='number'
          name='delivery_minimum'
          legend='Order Minimum'
          prefix='$'
        />
      </Grid>
      <Grid item xs={12}>
        <Divider />
      </Grid>
      <Grid item xs={12}>
        <DrawnZonesMap
          setFieldValue={setFieldValue}
          latLngs={long_lat}
          isValidateError={!!missCoordinateErr}
          ref={drawnZoneMapRef}
          defaultCenter={defaultCenter}
        />
        {missCoordinateErr ? (
          <FormHelperText error>{missCoordinateErr}</FormHelperText>
        ) : null}
      </Grid>
    </Grid>
  );
};
